import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getHouses = async (streetIds) => {
  const res = await request.get(
    '/Request/streets_houses',
    {
      streetIds: streetIds,
    },
    'При загрузке домов произошла ошибка',
    []
  );
  return res;
};

export const useHouses = (streetIds, options) =>
  useQuery(['houses', streetIds], () => getHouses(streetIds), {
    ...options,
  });

export default useHouses;
